export default ({ id, fullWidth, embededCode }) => ({
  id,
  fullWidth,
  embedCode: embededCode.embededCode,
});
